module.exports = __webpack_public_path__ + "static/media/bannerFooter.33620d53.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/Footer/bannerFooter.PNG
// module id = 529
// module chunks = 0